export const EVENT_NAME = {
  BETSLIP_OPENED: "Betslip Opened",
  WAGERPAD_CTA_CLICKED: "Wagerpad CTA Clicked",
  WAGERPAD_PAGE_VIEWED: "Wagerpad Page Viewed",
  WAGERPAD_DROPDOWN_SELECTED: "Wagerpad Dropdown Selected"
};
